/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Type_Back_In_StockInputs */

const he_notifications_type_back_in_stock = /** @type {(inputs: Notifications_Type_Back_In_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חזרה למלאי`)
};

const en_notifications_type_back_in_stock = /** @type {(inputs: Notifications_Type_Back_In_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back in Stock`)
};

/**
* | output |
* | --- |
* | "Back in Stock" |
*
* @param {Notifications_Type_Back_In_StockInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_type_back_in_stock = /** @type {((inputs?: Notifications_Type_Back_In_StockInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Type_Back_In_StockInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_type_back_in_stock(inputs)
	return en_notifications_type_back_in_stock(inputs)
});